import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const SkeletonContainer = () => {
  return (
    <div className="">
        <Skeleton className='h-[140px] cursor-pointer sm:w-[320px] sm:h-[270px] rounded-md'/>
        {/* <div className="card__title loading"></div>
        <div className="card__description loading"></div> */}
    </div>
  )
}

export default SkeletonContainer